
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function init(root) {
    if (!root || root.dataset.wbcInited === '1') return;
    root.dataset.wbcInited = '1';

    var sid = root.dataset.sectionId;

    var dataEl = document.getElementById('wybot-compare-data-' + sid);
    var products = [];
    if (dataEl) {
      try {
        var parsed = JSON.parse(dataEl.textContent || '{}');
        products = parsed.products || [];
      } catch (e) {
        // Do NOT abort init — keep dropdowns/sticky interactive even if data fails.
        console.error('[WYBOT Compare] invalid data JSON', e);
      }
    } else {
      console.warn('[WYBOT Compare] no data JSON (compare_collection not set?)');
    }

    var table = document.getElementById('wybot-compare-table-' + sid);
    if (!table) return;

    // Series order (e.g. "A,B,C,S") — used for default-slot filling AND for
    // matching the dropdown group order rendered in Liquid.
    var seriesOrder = root.dataset.seriesOrder || 'A,B,C,S';
    var seriesList = seriesOrder.split(',');

    var slots = [];
    $$('.wybot-compare__column', root).forEach(function (colEl, idx) {
      var slotIndex = idx + 1;
      var dropdown = $('.wybot-compare__dropdown', colEl);
      var product = $('.wybot-compare__product', colEl);
      slots.push({
        index: slotIndex,
        handle: '',
        colEl: colEl,
        dropdownEl: dropdown,
        trigger: dropdown && dropdown.querySelector('[data-dropdown-trigger]'),
        label: dropdown && dropdown.querySelector('[data-dropdown-label]'),
        menu: dropdown && dropdown.querySelector('.wybot-compare__dropdown-menu'),
        productEl: product,
        img: product && product.querySelector('[data-product-img]'),
        priceEl: product && product.querySelector('[data-product-price]'),
        learnEl: product && product.querySelector('[data-product-learn]'),
        urlEls: product ? product.querySelectorAll('[data-product-url], [data-product-buy]') : []
      });
    });

    var rows = $$('.wybot-compare__row--spec', table);
    var rowGroups = $$('.wybot-compare__row--group', table);

    var MOBILE_BREAKPOINT = 769;
    function isMobile() { return window.innerWidth <= MOBILE_BREAKPOINT; }
    function visibleSlots() { return isMobile() ? [1, 2] : [1, 2, 3]; }

    function applyResponsive() {
      root.classList.toggle('is-mobile', isMobile());
      applyHighlight();
    }

    var highlightToggle = document.getElementById('highlight-toggle-' + sid);
    if (highlightToggle) {
      highlightToggle.addEventListener('change', function () {
        applyHighlight();
      });
    }

    function findProduct(handle) {
      for (var i = 0; i < products.length; i++) {
        if (products[i].handle === handle) return products[i];
      }
      return null;
    }

    function closeAllDropdowns(except) {
      slots.forEach(function (s) {
        if (s.dropdownEl && s.dropdownEl !== except) {
          s.dropdownEl.classList.remove('is-open');
          if (s.menu) s.menu.hidden = true;
          if (s.trigger) s.trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function openDropdown(s) {
      if (!s.dropdownEl) return;
      closeAllDropdowns(s.dropdownEl);
      s.dropdownEl.classList.add('is-open');
      if (s.menu) s.menu.hidden = false;
      if (s.trigger) s.trigger.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown(s) {
      if (!s.dropdownEl) return;
      s.dropdownEl.classList.remove('is-open');
      if (s.menu) s.menu.hidden = true;
      if (s.trigger) s.trigger.setAttribute('aria-expanded', 'false');
    }

    function clearSlot(slotIndex) {
      var s = slots[slotIndex - 1];
      if (!s) return;
      s.handle = '';
      renderProduct(s, null);
      renderColumn(s, null);
      refreshDropdownSelection(s);
      refreshDropdownsAvailability();
      applyHighlight();
    }

    var PLACEHOLDER_IMG = "data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'%3E%3Crect width='200' height='200' fill='%23f2f2f2'/%3E%3C/svg%3E";

    function renderProduct(s, product) {
      if (!s.productEl) return;
      var customImg = product && product.custom_image;

      // Nothing to show at all: full reset
      if (!product && !customImg) {
        if (s.img) { s.img.src = PLACEHOLDER_IMG; s.img.alt = ''; }
        if (s.priceEl) { s.priceEl.innerHTML = '—'; }
        s.urlEls.forEach(function (el) { el.setAttribute('href', '#'); });
        if (s.learnEl) { s.learnEl.setAttribute('href', '#'); }
        return;
      }

      // Render product data
      if (product) {
        if (s.img) { s.img.src = product.image || PLACEHOLDER_IMG; s.img.alt = product.title || ''; }
        if (s.priceEl) {
          var priceHtml = '<span class="current-price">' + (product.price || product.price_min || '') + '</span>';
          if (product.compare_at_price && product.compare_at_price !== product.price && product.compare_at_price !== product.price_min) {
            priceHtml += '<span class="compare-price">' + product.compare_at_price + '</span>';
          }
          s.priceEl.innerHTML = priceHtml;
        }
        s.urlEls.forEach(function (el) { el.setAttribute('href', product.url || '#'); });
        if (s.learnEl) { s.learnEl.setAttribute('href', product.learn_url || product.url || '#'); }
      } else {
        // No product but custom values exist → placeholder for non-custom fields
        if (s.img) { s.img.src = PLACEHOLDER_IMG; s.img.alt = ''; }
        if (s.priceEl) s.priceEl.innerHTML = '—';
        s.urlEls.forEach(function (el) { el.setAttribute('href', '#'); });
        if (s.learnEl) { s.learnEl.setAttribute('href', '#'); }
      }

      // Custom overrides: ALWAYS apply last, regardless of product state
      if (customImg && s.img) { s.img.src = customImg; }
    }

    function renderColumn(s, product) {
      var slotIndex = s.index;
      rows.forEach(function (row) {
        var td = row.querySelector('[data-cell-col="' + slotIndex + '"]');
        if (!td) return;
        var valEl = td.querySelector('[data-val-' + slotIndex + ']');
        if (!valEl) return;

        var key = row.dataset.specKey;
        var val = '';
        if (product && product.specs && product.specs[key] != null) {
          val = product.specs[key];
        }
        valEl.classList.remove('wbc-yes', 'wbc-no', 'is-empty');
        valEl.innerHTML = '';
        if (val === '' || val == null) {
          valEl.classList.add('is-empty');
        } else if (val === '✓') {

          valEl.innerHTML = '<span class="wbc-yes" aria-label="Yes"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="currentColor"/><path d="M6.5 11.5 L10.5 16 L17.5 8" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg></span>';
        } else if (val === '✕') {

          valEl.innerHTML = '<span class="wbc-no" aria-label="No"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#d0d0d0"/><path d="M8 8 L16 16 M16 8 L8 16" stroke="#7a7a7a" stroke-width="2" stroke-linecap="round" fill="none"/></svg></span>';
        } else if (typeof val === 'string' && val.indexOf('Min.') !== -1 && val.indexOf('Max.') !== -1) {
          // Always break Min. / Max. ranges onto two lines regardless of cell width.
          valEl.innerHTML = val.replace(/\s*Max\./, '<br>Max.');
        } else {
          valEl.textContent = val;
        }
        td.classList.remove('is-diff-val');
      });
    }

    function refreshDropdownSelection(s) {
      if (!s.menu) return;
      $$('.wybot-compare__dropdown-item', s.menu).forEach(function (item) {
        item.classList.toggle('is-selected', item.dataset.value === s.handle);
      });
      if (s.label) {
        var product = s.handle ? findProduct(s.handle) : null;
        if (product) {
          s.label.textContent = product.custom_title || product.title;
          s.dropdownEl.classList.remove('is-empty');
        } else {
          s.label.textContent = s.dropdownEl.dataset.placeholder || 'Select a product';
          s.dropdownEl.classList.add('is-empty');
        }
      }
    }

    function refreshDropdownsAvailability() {
      slots.forEach(function (s) {
        if (!s.menu) return;
        $$('.wybot-compare__dropdown-item', s.menu).forEach(function (item) {
          if (!item.dataset.value) return;
          var isSelected = s.handle && item.dataset.value === s.handle;
          item.classList.toggle('is-selected', isSelected);
        });
      });
      var stickyBar = root.querySelector('[data-sticky-bar]');
      if (stickyBar) {
        $$('[data-sticky-item]', stickyBar).forEach(function (item) {
          if (!item.dataset.value) return;
          var slotIndex = parseInt(item.closest('[data-slot-index]').dataset.slotIndex, 10);
          var isSelected = slots[slotIndex - 1] && slots[slotIndex - 1].handle === item.dataset.value;
          item.classList.toggle('is-selected', isSelected);
        });
      }
    }

    function applyHighlight() {
      var enabled = highlightToggle && highlightToggle.checked;
      root.classList.toggle('is-highlight', !!enabled);

      rows.forEach(function (row) {
        row.classList.remove('is-diff', 'is-same');
        $$('.wybot-compare__td', row).forEach(function (td) { td.classList.remove('is-diff-val'); });
      });
      rowGroups.forEach(function (g) { g.classList.remove('is-hide'); });

      if (!enabled) return;

      var vslots = visibleSlots();

      rows.forEach(function (row) {
        var vals = [];
        vslots.forEach(function (i) {
          var v = row.querySelector('[data-cell-col="' + i + '"]');
          if (!v) return;
          var ve = v.querySelector('[data-val-' + i + ']');
          var isEmpty = ve ? ve.classList.contains('is-empty') : false;
          var text = ve ? (ve.textContent || '').trim() : '';
          text = isEmpty ? '—' : text;
          // Include the yes/no icon state so a ✓ vs ✕ row counts as different.
          // (✓/✕ render as SVG with empty textContent, so text alone can't tell them apart.)
          var icon = ve && ve.querySelector('.wbc-yes') ? 'YES'
                   : ve && ve.querySelector('.wbc-no') ? 'NO' : '';
          var cmp = icon ? (icon + '|' + text) : text;
          vals.push({ col: i, text: cmp });
        });

        if (vals.length < 2) {
          row.classList.add('is-same');
          return;
        }

        var allSame = vals.every(function (o) { return o.text === vals[0].text; });
        if (allSame) {
          row.classList.add('is-same');
        } else {
          row.classList.add('is-diff');
          vals.forEach(function (o) {
            var td = row.querySelector('[data-cell-col="' + o.col + '"]');
            if (td) td.classList.add('is-diff-val');
          });
        }
      });

      // With "differences only", hide any group whose specs are all identical.
      rowGroups.forEach(function (g) {
        var gname = g.getAttribute('data-group');
        var anyDiff = false;
        rows.forEach(function (row) {
          if (row.getAttribute('data-spec-group') === gname && !row.classList.contains('is-same')) {
            anyDiff = true;
          }
        });
        if (!anyDiff) g.classList.add('is-hide');
      });
    }

    function setSlot(slotIndex, handle, opts) {
      opts = opts || {};
      var s = slots[slotIndex - 1];
      if (!s) return;

      var product = findProduct(handle);
      if (!product) {
        clearSlot(slotIndex);
        return;
      }

      if (!opts.skipDuplicateCheck) {
        for (var i = 0; i < slots.length; i++) {
          if (slots[i].index !== slotIndex && slots[i].handle === handle) {
            var swappedHandle = s.handle;
            var conflictIdx = slots[i].index;
            clearSlot(conflictIdx);
            if (swappedHandle) {
              setSlot(conflictIdx, swappedHandle, { skipDuplicateCheck: true });
            }
            break;
          }
        }
      }

      s.handle = handle;
      renderProduct(s, product);
      renderColumn(s, product);
      refreshDropdownSelection(s);
      refreshDropdownsAvailability();
      applyHighlight();
      closeDropdown(s);
    }

    slots.forEach(function (s) {
      if (s.trigger) {
        s.trigger.addEventListener('click', function (e) {
          e.stopPropagation();
          if (s.dropdownEl.classList.contains('is-open')) closeDropdown(s);
          else openDropdown(s);
        });
      }
      if (s.menu) {
        $$('.wybot-compare__dropdown-item', s.menu).forEach(function (item) {
          item.addEventListener('click', function (e) {
            e.stopPropagation();
            setSlot(s.index, item.dataset.value);
          });
        });
      }
    });

    document.addEventListener('click', function (e) {
      var inAnyDropdown = false;
      slots.forEach(function (s) {
        if (s.dropdownEl && s.dropdownEl.contains(e.target)) inAnyDropdown = true;
      });
      if (!inAnyDropdown) closeAllDropdowns(null);
    });

    slots.forEach(function (s) {
      var def = s.dropdownEl && s.dropdownEl.dataset.defaultHandle;
      if (def) setSlot(s.index, def, { skipDuplicateCheck: true });
      refreshDropdownSelection(s);
    });

    // Default slots: fill EVERY empty select on first load with the next
    // available product, so all three slots show a product as long as the
    // collection has at least three items. Order = series A→B→C→S first,
    // then any remaining products. Already-used handles are never reused.
    var usedHandles = {};
    slots.forEach(function (s) {
      if (s.handle) usedHandles[s.handle] = true;
    });

    var orderedHandles = [];
    for (var si = 0; si < seriesList.length; si++) {
      for (var pi = 0; pi < products.length; pi++) {
        if (products[pi].series === seriesList[si]) {
          orderedHandles.push(products[pi].handle);
        }
      }
    }
    // Any product not picked up above (no series or unknown series) goes last.
    for (var pi2 = 0; pi2 < products.length; pi2++) {
      if (orderedHandles.indexOf(products[pi2].handle) === -1) {
        orderedHandles.push(products[pi2].handle);
      }
    }

    var fillIdx = 0;
    slots.forEach(function (s) {
      if (s.handle) return; // already filled (e.g. via schema default handle)
      while (fillIdx < orderedHandles.length && usedHandles[orderedHandles[fillIdx]]) {
        fillIdx++;
      }
      if (fillIdx >= orderedHandles.length) return;
      var handle = orderedHandles[fillIdx];
      usedHandles[handle] = true;
      fillIdx++;
      setSlot(s.index, handle, { skipDuplicateCheck: true });
    });

    applyResponsive();
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyResponsive, 80);
    });

    initStickyBar();

    function initStickyBar() {
      var stickyBar = root.querySelector('[data-sticky-bar]');
      if (!stickyBar) return;
      var productCards = root.querySelector('.wybot-compare__top');
      if (!productCards) return;

      function closeStickyMenus() {
        stickyBar.querySelectorAll('.wybot-compare__sticky-menu').forEach(function (m) { m.hidden = true; });
        stickyBar.querySelectorAll('.wybot-compare__sticky-dropdown').forEach(function (d) { d.classList.remove('is-open'); });
      }

      var _stickyShown = false;
      function setStickyShown(show) {
        if (show === _stickyShown) return;
        _stickyShown = show;
        if (show) {
          stickyBar.classList.add('is-shown');
        } else {
          stickyBar.classList.remove('is-shown');
          closeStickyMenus();
        }
      }

      // Show the fixed picker bar as soon as the native select row reaches
      // the top of the viewport (its top edge scrolls above y=0) and would
      // The bar is toggled via visibility (no layout shift), so a passive
      // scroll listener no longer risks the iOS resize/reflow flicker loop.
      var updateStickyVisibility = function () {
        if (!productCards) return;
        var rect = productCards.getBoundingClientRect();
        setStickyShown(rect.top <= 0);
      };
      window.addEventListener('scroll', updateStickyVisibility, { passive: true });
      window.addEventListener('resize', updateStickyVisibility, { passive: true });
      updateStickyVisibility();

      stickyBar.querySelectorAll('[data-sticky-dropdown]').forEach(function (dropdown) {
        var slotIndex = parseInt(dropdown.dataset.slot, 10);
        var trigger = dropdown.querySelector('[data-sticky-trigger]');
        var menu = dropdown.querySelector('[data-sticky-menu]');

        trigger.addEventListener('click', function (e) {
          e.stopPropagation();
          var isOpen = dropdown.classList.contains('is-open');
          stickyBar.querySelectorAll('.wybot-compare__sticky-dropdown').forEach(function (d) {
            d.classList.remove('is-open');
            d.querySelector('.wybot-compare__sticky-menu').hidden = true;
            d.querySelector('.wybot-compare__sticky-trigger').setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            dropdown.classList.add('is-open');
            menu.hidden = false;
            trigger.setAttribute('aria-expanded', 'true');
          }
        });

        dropdown.querySelectorAll('[data-sticky-item]').forEach(function (item) {
          item.addEventListener('click', function (e) {
            e.stopPropagation();
            var handle = item.dataset.value;
            setSlot(slotIndex, handle);
            dropdown.classList.remove('is-open');
            menu.hidden = true;
            trigger.setAttribute('aria-expanded', 'false');
          });
        });
      });

      document.addEventListener('click', function (e) {
        if (!stickyBar.contains(e.target)) {
          stickyBar.querySelectorAll('.wybot-compare__sticky-dropdown.is-open').forEach(function (d) {
            d.classList.remove('is-open');
            d.querySelector('.wybot-compare__sticky-menu').hidden = true;
            d.querySelector('.wybot-compare__sticky-trigger').setAttribute('aria-expanded', 'false');
          });
        }
      });
    }

    function syncStickyFromSlots() {
      var stickyBar = root.querySelector('[data-sticky-bar]');
      if (!stickyBar) return;
      slots.forEach(function (s) {
        var stickySlot = stickyBar.querySelector('[data-slot-index="' + s.index + '"]');
        if (!stickySlot) return;
        var label = stickySlot.querySelector('[data-sticky-label]');
        var img = stickySlot.querySelector('[data-sticky-img]');
        var buyBtn = stickySlot.querySelector('[data-sticky-buy]');
        var learnBtn = stickySlot.querySelector('[data-sticky-learn]');
        if (s.handle) {
          var product = findProduct(s.handle);
          if (product) {
            var customImg = product && product.custom_image;
            label.textContent = product.custom_title || product.title;
            if (img) {
              img.src = customImg || product.image;
              img.alt = product.title || '';
            }
            if (buyBtn) buyBtn.href = product.url || '#';
            if (learnBtn) learnBtn.href = (product.learn_url || product.url) || '#';
            stickySlot.querySelectorAll('[data-sticky-item]').forEach(function (item) {
              item.classList.toggle('is-selected', item.dataset.value === s.handle);
            });
          }
        } else {
          label.textContent = 'Select a product';
          if (img) {
            img.src = 'data:image/svg+xml;utf8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 200 200\'%3E%3Crect width=\'200\' height=\'200\' fill=\'%23f2f2f2\'/%3E%3C/svg%3E';
            img.alt = '';
          }
          if (buyBtn) buyBtn.href = '#';
          if (learnBtn) learnBtn.removeAttribute('href');
          stickySlot.querySelectorAll('[data-sticky-item]').forEach(function (item) {
            item.classList.remove('is-selected');
          });
        }
      });
    }

    var _origRenderProduct = renderProduct;
    renderProduct = function (s, product) {
      _origRenderProduct(s, product);
      syncStickyFromSlots();
    };

    var _origRefreshDropdownSelection = refreshDropdownSelection;
    refreshDropdownSelection = function (s) {
      _origRefreshDropdownSelection(s);
      syncStickyFromSlots();
    };

    syncStickyFromSlots();

    root._wybotCompare = {
      setSlot: setSlot,
      clearSlot: clearSlot,
      applyHighlight: applyHighlight,
      applyResponsive: applyResponsive,
      isMobile: isMobile,
      products: products
    };
  }

  function boot() {
    $$('.wybot-compare').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector && e.target.querySelector('.wybot-compare');
    if (root) init(root);
  });
})();